module.exports = __webpack_public_path__ + "static/media/checkbox_false.bc37e981.svg";